/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 1ae6e2d8 (Tue May  5 20:16:57 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  EnrollmentBill,
  EnrollmentBillFromJSON,
  EnrollmentBillToJSON,
  EnrollmentPayment,
  EnrollmentPaymentFromJSON,
  EnrollmentPaymentToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchBillingResponseEnrollment
 */
export interface FetchBillingResponseEnrollment {
  /**
   *
   * @type EnrollmentBill
   * @memberof FetchBillingResponseEnrollment
   */
  owed?: EnrollmentBill
  /**
   *
   * @type {Array<EnrollmentPayment>}
   * @memberof FetchBillingResponseEnrollment
   */
  history?: Array<EnrollmentPayment>
}

export function FetchBillingResponseEnrollmentFromJSON(
  json: any
): FetchBillingResponseEnrollment {
  return FetchBillingResponseEnrollmentFromJSONTyped(json, false)
}

export function FetchBillingResponseEnrollmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchBillingResponseEnrollment {
  if (json === undefined || json === null) {
    return json
  }
  return {
    owed: !exists(json, 'owed')
      ? undefined
      : EnrollmentBillFromJSON(json['owed']),
    history: !exists(json, 'history')
      ? undefined
      : (json['history'] as Array<any>).map(EnrollmentPaymentFromJSON),
  }
}

export function FetchBillingResponseEnrollmentToJSON(
  value?: FetchBillingResponseEnrollment | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    owed: EnrollmentBillToJSON(value.owed),
    history:
      value.history === undefined
        ? undefined
        : (value.history as Array<any>).map(EnrollmentPaymentToJSON),
  }
}
